import React from "react";
import ProgramTemplate from "@/components/ProgramTemplate";
import { PROGRAM_MEM_67 } from "@/lib/programData";

export default function MarrakechLoop67Page() {
  return <ProgramTemplate program={PROGRAM_MEM_67} variant="mem" showJourneyChronology />;
}
